import Vue from 'vue'
import App from './App.vue'
import router from './router' // 导入路由实例
import axios from 'axios'
// 2. 将axios挂载到Vue原型上，命名为$axios（$前缀是Vue生态的约定，区分自定义属性和原生属性）
Vue.prototype.$axios = axios

// 可选：配置axios全局默认值（比如基础域名、超时时间等）
axios.defaults.baseURL = 'https://www.3pg.cn' // 接口基础域名
axios.defaults.timeout = 10000 // 请求超时时间（10秒）


// 引入CloudBase初始化实例
import cloudbase from './utils/cloudbase'
// 全局挂载：所有组件可通过this.$tcb访问tcb实例，this.$db访问数据库
Vue.prototype.$tcb = cloudbase.app
Vue.prototype.$db = cloudbase.db



// 引入全局 CSS 文件（注意路径要正确）
import './styles/global.css'  // 引入全局样式
import './styles/iconfont.css'  // 引入ICON图标库
import 'animate.css'

// 引入 Element UI
import ElementUI from 'element-ui'
// 引入 Element UI 样式
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)

import VueAMap from '@vuemap/vue-amap';
import '@vuemap/vue-amap/dist/style.css';
Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: '3a8478fa46c6299d5f44635c059af55a'
});

// 引入全局组件注册函数
import { registerGlobalComponents } from './components/global'
// const app = createApp(App)

// 注册全局组件
// registerGlobalComponents(app)
registerGlobalComponents(Vue)

// 引入 wowjs
import { WOW } from 'wowjs'
// 全局实例化 WOW
Vue.prototype.$wow = new WOW({
  boxClass: 'wow', // 触发动画的元素类名（默认即可）
  animateClass: 'animated', // 动画类名前缀（对应 animate.css 的类）
  offset: 0, // 元素距离视口多少像素时触发动画
  mobile: true, // 是否在移动端触发动画（移动端建议开启）
  live: true // 是否监听动态添加的元素
})


// 核心配置项
const config = {
  // 基础断点（可根据需求调整）
  breakpoint: 768,
  // 缓冲区间：避免折叠屏等中间尺寸频繁触发（±20px）
  buffer: 20,
  // 防抖延迟：500ms，确保尺寸稳定后再判断
  debounceDelay: 500,
  // 目标网址
  pcUrl: 'https://www.3pg.cn',
  mobileUrl: 'https://m.3pg.cn'
}

/**
 * 防抖函数：避免频繁触发
 * @param {Function} func 执行函数
 * @param {Number} delay 延迟时间
 * @returns {Function} 防抖后的函数
 */
function debounce(func, delay) {
  let timer = null
  return function(...args) {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, delay)
  }
}

/**
 * 判断并执行跳转逻辑
 */
function handleScreenRedirect() {
  const screenWidth = window.innerWidth
  const currentUrl = window.location.href
  
  // 1. 计算有效阈值（加入缓冲）
  const lowerThreshold = config.breakpoint - config.buffer
  const upperThreshold = config.breakpoint + config.buffer

  // 2. 判断当前应该跳转的目标
  let targetUrl = ''
  if (screenWidth <= lowerThreshold) {
    // 小屏：移动端
    targetUrl = config.mobileUrl
  } else if (screenWidth >= upperThreshold) {
    // 大屏：PC端
    targetUrl = config.pcUrl
  } else {
    // 中间尺寸（折叠屏）：不跳转，保持当前页面
    return
  }

  // 3. 避免重复跳转（当前已在目标网址则不处理）
  if (currentUrl.includes(targetUrl) || currentUrl === targetUrl) {
    return
  }

  // 4. 执行跳转
  window.location.href = targetUrl
}

// 开发时关闭  项目打包时要打开 页面加载时立即执行一次判断
handleScreenRedirect()

// 监听窗口尺寸变化，加入防抖避免频繁触发
window.addEventListener('resize', debounce(handleScreenRedirect, config.debounceDelay))


import AV from 'leancloud-storage'
// const AV = require("leancloud-storage");
// const { Query, User } = AV;

AV.init({
  appId: '9rXqIZHsGPUfozzLKmCRzDaU-gzGzoHsz',
  appKey: 'W4rV92VWVQq2GRbXEjf93tSb',
  serverURL: 'https://9rxqizhs.lc-cn-n1-shared.com'
})
Vue.prototype.$AV = AV

// 创建Vue实例
new Vue({
  el: '#app',
  router, // 使用路由
  render: h => h(App)
})
